import { render, staticRenderFns } from "./VacanciesList.vue?vue&type=template&id=0cb0d844&scoped=true&"
import script from "./VacanciesList.vue?vue&type=script&lang=js&"
export * from "./VacanciesList.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesList.vue?vue&type=style&index=0&id=0cb0d844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0d844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
